import { PayloadAction } from '@reduxjs/toolkit';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { STATE__network } from './STATE__network';

export const local_network_set_errors = (errors: DTO_RESPONSE__error[]): PayloadAction<DTO_RESPONSE__error[]> => ({
  type: ENUM__redux_action.NETWORK_SET_ERRORS,
  payload: errors,
});

export const init_local_network_set_errors = (state: STATE__network, action: PayloadAction<DTO_RESPONSE__error[]>) => {
  state.errors = action.payload;
};
